'use client';

import { useTranslations } from 'next-intl';
import SubscribeForm from './subscribe-form';

const Title = () => {
  const t = useTranslations('Footer');
  return (
    <div className="mb-[25px] block text-base font-normal text-3b-blue-light-900 lg:text-xl">
      {t('subscribe.title')}
    </div>
  );
};

const NewsLetterSubscription = () => {
  return (
    <div className="footer-newsletter w-full pt-[60px] main-hero:max-xl:w-full main-hero:max-xl:pt-0 lg:w-[490px] lg:pt-0 main-hero:[&>div:first-child]:max-xl:mb-4 main-hero:[&>div:first-child]:max-xl:text-[14px] main-hero:[&>div:first-child]:max-xl:font-semibold">
      <Title />
      <div>
        <SubscribeForm />
      </div>
    </div>
  );
};

export default NewsLetterSubscription;
